<template>
  <step :context="context" image="/images/gift.svg" @back="$emit('back')" @submit="submit">
    <template #guideTitle>Your new program is just around the corner</template>
    <template #guideDescription>
      <div>
        <b>1. Earn & Redeem—</b>Your members will be able to earn rewards for visits and purchases. choose one of the following options.
      </div>
      <div>
        <b>2. Joining Gift—</b>Please specify exact cash discount amount that will incentivize your users to join your loyalty program.
      </div>
      <div>
        <b>3. Birthday Gift—</b>Please specify exact cash discount amount to give your users on their birthday.
      </div>
    </template>
    <template #formTitle>Core Loyalty Program Setup</template>
    <template #form>
      <v-form class="form" v-model="valid" ref="form">
        <!-- Earn/Redeem -->
        <form-section header="1. Earn and Redeem">
          <v-radio-group
            class="mt-0 pt-0"
            v-model="model.earnAndRedeem.value"
            hide-details
            :rules="[rules.required]"
          >
            <custom-radio label="Points Accumulation" value="accumulation" v-slot="{selected}">
              <v-text-field
                class="minimal"
                v-model="model.earnAndRedeem.accumulation"
                suffix="%"
                hide-details
                :rules="selected ? [rules.required, rules.percentage] :  []"
              />
            </custom-radio>
            <div
              class="hint"
            >1 point= ₺1 in rewards. Specify the percentage discount. For example, 10% will give the user 1 point for a ₺10 purchase.</div>
            <div>
              <custom-radio label="Punch Card" value="punch" v-slot="{selected}" indent>
                <template>
                  <div>Buy</div>
                  <v-text-field
                    class="minimal"
                    placeholder="5"
                    v-model="model.earnAndRedeem.punch.buy"
                    :rules="selected ? [rules.required, rules.number] : []"
                  />
                  <v-text-field
                    class="minimal-2"
                    placeholder="Specify item/s"
                    v-model="model.earnAndRedeem.punch.items"
                    :rules="[!selected || rules.required]"
                  />
                  <div>Get</div>
                  <v-text-field
                    class="minimal"
                    placeholder="1"
                    v-model="model.earnAndRedeem.punch.getFree"
                    :rules="selected ? [rules.required, rules.number] : []"
                  />
                  <div>Free</div>
                </template>
              </custom-radio>
            </div>
          </v-radio-group>
        </form-section>

        <!-- Joining Gift Discount -->
        <form-section
          header="2. Joining Gift—Cash Discount"
          tooltip="Como Sense Professional offers various discount options, such as percentage discount, free item, and more."
        >
          <div class="inline">
            <div>Enter cash discount</div>
            <v-text-field
              class="minimal"
              prefix="₺"
              placeholder="5"
              v-model="model.joiningGiftDiscount"
              :rules="[rules.required, rules.number]"
            />
          </div>
        </form-section>

        <!-- Birthday Discount -->
        <form-section header="3. Birthday Gift—Cash Discount" optional>
          <div class="inline">
            <div>Enter cash discount</div>
            <v-text-field
              class="minimal"
              prefix="₺"
              placeholder="5"
              v-model="model.birthdayGiftDiscount"
              :rules="[rules.number]"
            />
          </div>
        </form-section>
      </v-form>
    </template>
  </step>
</template>

<script>
import Step from "../Step";
import FormSection from "../FormSection";
import CustomRadio from "../CustomRadio";

export default {
  props: ["context"],
  components: {
    Step,
    FormSection,
    CustomRadio
  },
  data() {
    return {
      valid: false,
      rules: {
        required: v => !!v || "Field is required",
        number: v => v == null || !isNaN(Number(v)) || "Value must be a number",
        percentage: v =>
          (!isNaN(Number(v)) && v >= 0 && v <= 100) ||
          "Value must be a percentage"
      },
      model: {
        earnAndRedeem: {
          value: null,
          accumulation: null,
          punch: {
            buy: null,
            items: null,
            getFree: null
          }
        },
        joiningGiftDiscount: null,
        birthdayGiftDiscount: null,
        ...this.context.submittedData
      }
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate())
        this.$emit("done", { ...this.$data.model });
    }
  }
};
</script>